/**
 * Which board→editor reveal a plain SELECT is allowed to make.
 *
 * Selecting a node reveals its declaration in the editor — but a reveal goes
 * through `store.requestReveal` → `setActiveFile` → `openTab`, which OPENS and
 * ACTIVATES the target file's tab. So an unconditional reveal turns a single
 * board click into a tab switch, yanking the user off the file they're editing
 * (and, because panel state like the details rail is remembered per tab,
 * making that panel appear to toggle itself on selection).
 *
 * The rule: a select only scrolls the editor when the declaration is in the
 * file already on screen. Cross-file "go to source" stays an explicit gesture
 * (go-to-definition / the issue popover), never a side effect of selecting.
 */

/** The declaration location a select resolved to, in STORE key form. */
export interface DeclLocation {
  readonly path: string;
  readonly line: number;
}

/** The reveal a select should issue, or null to leave the editor alone. */
export function revealForSelect(
  loc: DeclLocation | null,
  activeFile: string | null,
): DeclLocation | null {
  if (!loc || activeFile === null) return null;
  return loc.path === activeFile ? loc : null;
}
